import { LoadingOutlined } from "@ant-design/icons";
import React, { useEffect, useState } from "react";
import axios from 'axios'
import { Auth } from "../../../config/aws-exports";
// Redux
import { connect, useDispatch, useSelector } from "react-redux";
import { updateCompanyProfileDetails, updateImpersonationIdId, updateUserInfo } from "../../../redux/actions";
import { fetchUserProfile } from "../../../redux/actions";

import { getCookie, setCookie } from "../../../shared/helpers";
import { useHistory, useLocation } from "react-router-dom";
import { addUpdateUserDeviceDeatils } from "../../../API/API";
// import history from "../../../routes/history";


const AuthSuccess = (props) => {
  const history = useHistory();
  const location = useLocation().search;
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const asEmployer = localStorage.getItem('asEmployer');
  const dispatch = useDispatch();

  const userId = new URLSearchParams(location).get("userId");
  const adminToken = new URLSearchParams(location).get("token");
  const redirectUrl = new URLSearchParams(location).get("redirectUrl");
  if(redirectUrl){
  localStorage.setItem("redirectUrl", redirectUrl);
}
  const updateAsEmployer = () => {
    localStorage.removeItem('asEmployer')
    dispatch(
      updateCompanyProfileDetails({
        AccountTypeCode: "EMP",
        WizardFlow: 0,
      })
    );
  };
  const getUserDeviceDetails = (IPAddress) => {
    const userAgent = navigator.userAgent;
    let DeviceType, DeviceName, AdditionalInfo;
  
    if (/Windows/i.test(userAgent)) {
      DeviceType = "Desktop";
      DeviceName = "Windows";
      AdditionalInfo = userAgent;
    } else if (/Macintosh/i.test(userAgent)) {
      DeviceType = "Desktop";
      DeviceName = "Mac";
      AdditionalInfo = userAgent;
    } else if (/Android/i.test(userAgent)) {
      DeviceType = /Mobile|Tablet/i.test(userAgent) ? "Mobile" : "Tablet";
      DeviceName = userAgent.match(/(Android [\d.]+)/)?.[1];
      AdditionalInfo = userAgent;
    } else if (/iPhone|iPad|iPod/i.test(userAgent)) {
      DeviceType = /iPad/i.test(userAgent) ? "Tablet" : "Mobile";
      DeviceName = userAgent.match(/(iPhone|iPod|iPad);.*CPU.*OS (\d+)/i)?.[1];
      AdditionalInfo = userAgent;
    } else {
      DeviceType = "Unknown";
      DeviceName = userAgent;
      AdditionalInfo = userAgent;
    }
  
    return {
      DeviceName,
      DeviceType,
      AdditionalInfo,
      IPAddress,
    };
  };

  // debugger;
  useEffect(async () => {
    const getIpAddress = async () => {
      const response = await axios.get("https://api.ipify.org?format=json");
      if(response?.data) {
        console.log('response data in auth success', response)
        addUpdateUserDeviceDeatils(getUserDeviceDetails(response?.data?.ip))
      }
    };

    getIpAddress()

    let session = null;
    try {
      if (userId && adminToken) {
        // superadmin impersonating user
        setCookie("token", adminToken, true);
        setCookie("impersonationid", userId);
        props.updateImpersonationId(userId);
        props.sendAuthToken(adminToken);
        props.profileDetails({ token: adminToken, impersonationId: userId });
      } else if (getCookie("token") !== null && getCookie("token").length > 0) {
        const token = getCookie("token");
        props.profileDetails(token);
        // dispatch(fetchUserProfile(token))
        // props.sendAuthToken(token); linked token already save at this point in reducer
      } else if ((session = await Auth.currentSession())) {
        // const session = await Auth.currentSession();
        const token = session.getIdToken().getJwtToken();
        setCookie("token", token);
        props.profileDetails(token);
        // dispatch(fetchUserProfile(token))
        props.sendAuthToken(token);
      } else {
        history.push("/login");
      }
    } catch (err) {
      history.push("/login");
    }
  }, []);

  useEffect(() => {
    window.name = "talentemployer";
    //used for redirecting guest user flow
    const redirectTo = localStorage.getItem("redirectTo");
    const redirectToPath = localStorage.getItem("pathnameonclosing")
    // if (redirectTo) {
    //   localStorage.removeItem("redirectTo");
    // }
    // const profile = pr;
    // setState(data);



    // return;
    if (profile?.EmailAddress) {
      if (profile?.MasterAccountId != null) {
        window.name = "employerdashboard";
        setCookie('finishProfile', 'true')
        history.push('/employerdashboard');
      } else if (profile.AccountTypeCode == null && asEmployer) {
        window.name = "employerprofession";
        setCookie('finishProfile', '')
        updateAsEmployer()
        window.location.replace("/employer/employerprofession")
      } else if (profile.AccountTypeCode == null) {
        history.push("/talentemployer");
        // } else if (profile.Profiles.AccountTypeCode == null) {
      } else if (profile?.Professions?.ProfessionCode == null) {
        window.name = "employerprofession";
        setCookie('finishProfile', '')
        window.location.replace("/employer/employerprofession")
      } else if (profile.Profiles.CompanyName == null) {
        window.name = "companydetails";
        setCookie('finishProfile', '')
        window.location.replace("/employer/companydetails");
      } else if (profile.Profiles.FirstName == null) {
        window.name = "personaldetails";
        history.push("/personaldetails");
      } else if (localStorage.getItem("redirectUrl")) {
        
        let newRedirectedUrl = localStorage.getItem("redirectUrl");
        //check string have messages
        if (newRedirectedUrl.includes("messages")){
          newRedirectedUrl = newRedirectedUrl.replace("messages", "conversations")
        }
        // string messages replace with conversations
        setCookie('finishProfile', 'true')
        history.push(newRedirectedUrl);
      } else {
        window.name = "employerdashboard";
        setCookie('finishProfile', 'true')
        // if (redirectToPath && redirectToPath !== "/login" && redirectToPath !== '/postajob/choosetemplate' && redirectToPath !== '/per-gig' && redirectToPath !== '/contract-gig' && redirectToPath !== '/CompanyLogo' && !redirectToPath.includes('/jobdetail') && !redirectToPath.includes('/profiledetail')) {
        //   window.location.replace(`/employer${redirectToPath}`);
        // }
        
          // setCookie('finishProfile', 'true')
          history.push('/employerdashboard')
        // history.push('/employerdashboard')
      }
    }
  }, [props.user, profile]);

  useEffect(() => {
    if (profile?.AccountTypeCode == "TAL" && props?.token?.authToken) {
      window.location.replace("/talent/auth");
    }
  }, [profile])

  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        fontSize: "2.5rem",
        margin: "40vh 0",
        color: "#118936",
      }}
    >
      <LoadingOutlined />
    </div>
  );
};

const mapStateToProps = (state) => {
  return {
    user: state.profileReducer.user,
    error: state.authReducer.error,
    token: state.authReducer.user,
    // userProfile: state.profileReducer.user.profile,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendAuthToken: (params) => {
      dispatch(updateUserInfo(params)); // action dispatched
    },
    profileDetails: (params) => {
      dispatch(fetchUserProfile(params)); // action dispatched
    },
    updateImpersonationId: (token) => {
      dispatch(updateImpersonationIdId(token)); // action dispatched
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(AuthSuccess);
